"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TILES_STADIUM = exports.TEAM_SIZE_SMALL = exports.TEAM_SIZE_MEDIUM = exports.TEAM_SIZE_LARGE = exports.STADIUM_SIZE = exports.STADIUM_REROLL_COACH_SUCCESS = exports.STADIUM = exports.removeTile = exports.removeLine = exports.remove = exports.priceSize = exports.minWidth = exports.minHeight = exports.MIN_SCRIMMAGE = exports.maxWidth = exports.maxHeight = exports.MAX_STORE = exports.MAX_LATERAL = exports.insertTile = exports.insertLine = exports.insert = exports.INITIAL_REROLL = exports.getTeamStadium = exports.getStadiumTypeProperty = exports.getStadiumStateProperty = exports.getStadiumSizeFromTeams = exports.getStadiumSizeFromGame = exports.getStadiumRerollCoach = exports.getStadiumReroll = exports.getStadiumFan = exports.getStadiumCapacityByGame = exports.getStadiumCapacity = exports.getStadium = exports.getRerollCoachCost = exports.COACH_REROLL_COST = exports.addCenterZone = void 0;
exports.splitList = splitList;
const random_1 = require("./random");
const INITIAL_REROLL = 2;
exports.INITIAL_REROLL = INITIAL_REROLL;
const MIN_SCRIMMAGE = 3; // TODO: in league param
exports.MIN_SCRIMMAGE = MIN_SCRIMMAGE;
const MAX_LATERAL = 2;
exports.MAX_LATERAL = MAX_LATERAL;
var STADIUM_SIZE;
(function (STADIUM_SIZE) {
    STADIUM_SIZE["SMALL"] = "s";
    STADIUM_SIZE["MEDIUM"] = "m";
    STADIUM_SIZE["LARGE"] = "l";
})(STADIUM_SIZE || (exports.STADIUM_SIZE = STADIUM_SIZE = {}));
const TEAM_SIZE_SMALL = 5;
exports.TEAM_SIZE_SMALL = TEAM_SIZE_SMALL;
const TEAM_SIZE_MEDIUM = 8;
exports.TEAM_SIZE_MEDIUM = TEAM_SIZE_MEDIUM;
const TEAM_SIZE_LARGE = 11;
exports.TEAM_SIZE_LARGE = TEAM_SIZE_LARGE;
const STADIUM = {
    [TEAM_SIZE_SMALL]: {
        zone: `bddddddaaaaaahhhhhhfbddddddaaaaaahhhhhhfbcccccjaaaaaakgggggfbcccccjaaaaaakgggggfbcccccjaaaaaakgggggfbcccccjaaaaaakgggggfbcccccjaaaaaakgggggfbcccccjaaaaaakgggggfbcccccjaaaaaakgggggfbeeeeeeaaaaaaiiiiiifbeeeeeeaaaaaaiiiiiif`,
        type: `aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa`,
        state: `0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000`,
        width: 20,
        height: 11,
        size: STADIUM_SIZE.SMALL,
    },
    [TEAM_SIZE_MEDIUM]: {
        zone: `bddddddddaaaahhhhhhhhfbddddddddaaaahhhhhhhhfbddddddddaaaahhhhhhhhfbcccccccjaaaakgggggggfbcccccccjaaaakgggggggfbcccccccjaaaakgggggggfbcccccccjaaaakgggggggfbcccccccjaaaakgggggggfbcccccccjaaaakgggggggfbcccccccjaaaakgggggggfbeeeeeeeeaaaaiiiiiiiifbeeeeeeeeaaaaiiiiiiiifbeeeeeeeeaaaaiiiiiiiif`,
        type: `aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa`,
        state: `0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000`,
        width: 22,
        height: 13,
        size: STADIUM_SIZE.MEDIUM,
    },
    [TEAM_SIZE_LARGE]: {
        zone: `bddddddddddddhhhhhhhhhhhhfbddddddddddddhhhhhhhhhhhhfbddddddddddddhhhhhhhhhhhhfbddddddddddddhhhhhhhhhhhhfbcccccccccccjkgggggggggggfbcccccccccccjkgggggggggggfbcccccccccccjkgggggggggggfbcccccccccccjkgggggggggggfbcccccccccccjkgggggggggggfbcccccccccccjkgggggggggggfbcccccccccccjkgggggggggggfbeeeeeeeeeeeeiiiiiiiiiiiifbeeeeeeeeeeeeiiiiiiiiiiiifbeeeeeeeeeeeeiiiiiiiiiiiifbeeeeeeeeeeeeiiiiiiiiiiiif`,
        type: `aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa`,
        state: `000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000`,
        width: 26,
        height: 15,
        size: STADIUM_SIZE.LARGE,
    },
};
exports.STADIUM = STADIUM;
const getStadiumSizeFromGame = (game) => {
    for (const info of Object.values(STADIUM)) {
        const { width, height, size } = info;
        if (game.stadium_width === width && game.stadium_height === height) {
            return size;
        }
    }
    return null;
};
exports.getStadiumSizeFromGame = getStadiumSizeFromGame;
const getStadium = (size) => {
    switch (size) {
        case STADIUM_SIZE.MEDIUM:
            return STADIUM[TEAM_SIZE_MEDIUM];
        case STADIUM_SIZE.LARGE:
            return STADIUM[TEAM_SIZE_LARGE];
        case STADIUM_SIZE.SMALL:
            return STADIUM[TEAM_SIZE_SMALL];
        default:
            return null;
    }
};
exports.getStadium = getStadium;
const getStadiumTypeProperty = (size) => {
    switch (size) {
        case STADIUM_SIZE.MEDIUM:
            return "stadium_type_m";
        case STADIUM_SIZE.LARGE:
            return "stadium_type_l";
        default:
            return "stadium_type_s";
    }
};
exports.getStadiumTypeProperty = getStadiumTypeProperty;
const getStadiumStateProperty = (size) => {
    switch (size) {
        case STADIUM_SIZE.MEDIUM:
            return "stadium_state_m";
        case STADIUM_SIZE.LARGE:
            return "stadium_state_l";
        default:
            return "stadium_state_s";
    }
};
exports.getStadiumStateProperty = getStadiumStateProperty;
const getStadiumSizeFromTeams = (team1, team2) => {
    if (team1.players.length < TEAM_SIZE_MEDIUM ||
        team2.players.length < TEAM_SIZE_MEDIUM) {
        return STADIUM_SIZE.SMALL;
    }
    if (team1.players.length < TEAM_SIZE_LARGE ||
        team2.players.length < TEAM_SIZE_LARGE) {
        return STADIUM_SIZE.MEDIUM;
    }
    return STADIUM_SIZE.LARGE;
};
exports.getStadiumSizeFromTeams = getStadiumSizeFromTeams;
const getTeamStadium = (team, size) => {
    const result = {
        zone: getStadium(size)?.zone,
        height: getStadium(size)?.height,
        width: getStadium(size)?.width,
    };
    switch (size) {
        case STADIUM_SIZE.MEDIUM:
            return {
                ...result,
                type: team.stadium_type_m,
                state: team.stadium_state_m,
            };
        case STADIUM_SIZE.LARGE:
            return {
                ...result,
                type: team.stadium_type_l,
                state: team.stadium_state_l,
            };
        default:
            return {
                ...result,
                type: team.stadium_type_s,
                state: team.stadium_state_s,
            };
    }
};
exports.getTeamStadium = getTeamStadium;
const TILES_STADIUM = {
    a: {
        y: 5,
        price: 0,
        wear: 80,
        icons: [0, 2, 4, 6, 8, 9],
    },
    b: {
        y: 4,
        price: 0,
        wear: 80,
        icons: [0, 2, 4, 6, 8, 9],
    },
    c: {
        y: 3,
        price: 0,
        wear: 80,
        icons: [0, 2, 4, 6, 8, 9],
    },
    d: {
        y: 1,
        price: 0,
        wear: 80,
        icons: [0, 2, 4, 6, 8],
    },
    e: {
        y: 2,
        price: 0,
        wear: 80,
        icons: [0, 2, 4, 6, 8],
    },
    f: {
        y: 0,
        price: 0,
        wear: 80,
        icons: [0, 2, 4, 6, 8],
    },
};
exports.TILES_STADIUM = TILES_STADIUM;
const minWidth = 20;
exports.minWidth = minWidth;
const maxWidth = 26;
exports.maxWidth = maxWidth;
const minHeight = 11;
exports.minHeight = minHeight;
const maxHeight = 15;
exports.maxHeight = maxHeight;
const priceSize = 20;
exports.priceSize = priceSize;
const COACH_REROLL_COST = 50;
exports.COACH_REROLL_COST = COACH_REROLL_COST;
const MAX_STORE = 5;
exports.MAX_STORE = MAX_STORE;
const getRerollCoachCost = (team) => {
    // 50, 100, 150, 200, 250
    return COACH_REROLL_COST * (team.rerollCoach + 1);
};
exports.getRerollCoachCost = getRerollCoachCost;
const getStadiumCapacityByGame = (game) => {
    return getStadiumCapacity(game.stadium_width, game.stadium_height);
};
exports.getStadiumCapacityByGame = getStadiumCapacityByGame;
const getStadiumCapacity = (_w, h) => {
    // Height: 11 13 15
    let nb = 5;
    if (h === 13) {
        nb += 3;
    }
    else if (h === 15) {
        nb += 6;
    }
    return nb > 11 ? 11 : nb;
};
exports.getStadiumCapacity = getStadiumCapacity;
const getStadiumFan = (_w, _h) => {
    // No more limit?
    let nb = 27;
    return nb;
};
exports.getStadiumFan = getStadiumFan;
const getStadiumReroll = (_w, h) => {
    let nb = INITIAL_REROLL;
    if (h === 13) {
        nb += 2;
    }
    else if (h === 15) {
        nb += 5;
    }
    return nb;
};
exports.getStadiumReroll = getStadiumReroll;
const STADIUM_REROLL_COACH_SUCCESS = 5;
exports.STADIUM_REROLL_COACH_SUCCESS = STADIUM_REROLL_COACH_SUCCESS;
const getStadiumRerollCoach = (team) => {
    let nb = 0;
    let results = [];
    for (let i = 0; i < team.rerollCoach; i++) {
        const result = (0, random_1.d6)();
        if (result >= STADIUM_REROLL_COACH_SUCCESS) {
            nb++;
        }
        results.push(result);
    }
    return { nb, results };
};
exports.getStadiumRerollCoach = getStadiumRerollCoach;
const insert = (str, index, value) => {
    return str.substr(0, index) + value + str.substr(index);
};
exports.insert = insert;
const remove = (str, index, nb = 1) => {
    return str.slice(0, index) + str.slice(index + nb);
};
exports.remove = remove;
const insertTile = (list, width, char) => {
    const lists = splitList(width, list) || [];
    lists.forEach((line, index) => {
        const noScrimage = line[line.length / 2 - 1] === "a";
        line = insert(line, 1, char ? char : line.charAt(1));
        if (!char && noScrimage) {
            line = insert(line, 1, char ? char : line.charAt(1));
        }
        line = insert(line, line.length - 1, char ? char : line.charAt(line.length - 2));
        if (!char && noScrimage) {
            line = insert(line, line.length - 1, char ? char : line.charAt(line.length - 2));
        }
        if (!char && noScrimage) {
            // Remove the "a"
            const charToRemovePosition = line.length / 2 - 1;
            line = remove(line, charToRemovePosition, 2);
        }
        lists[index] = line;
    });
    return lists.join("");
};
exports.insertTile = insertTile;
const addCenterZone = (list, width) => {
    const lists = splitList(width, list) || [];
    lists.forEach((line, index) => {
        // bccccccccjkggggggggf
        const centerToAdd = 26 - line.length - (line.match(/a/g) || []).length;
        if (centerToAdd <= 0) {
            return;
        }
        line = insert(line, line.length / 2, "a".repeat(centerToAdd));
        for (let i = 0; i < centerToAdd / 2; ++i) {
            line = remove(line, 1);
            line = remove(line, line.length - 2);
        }
        lists[index] = line;
    });
    return lists.join("");
};
exports.addCenterZone = addCenterZone;
const removeTile = (list, width) => {
    const lists = splitList(width, list) || [];
    lists.forEach((line, index) => {
        line = remove(line, 1);
        line = remove(line, line.length - 2);
        lists[index] = line;
    });
    return lists.join("");
};
exports.removeTile = removeTile;
const insertLine = (list, width, char) => {
    const lists = splitList(width, list) || [""];
    lists.unshift(lists[0]);
    lists.push(lists[lists.length - 1]);
    if (char) {
        lists[0] = char.repeat(lists[0].length);
        lists[lists.length - 1] = char.repeat(lists[lists.length - 1].length);
    }
    return lists.join("");
};
exports.insertLine = insertLine;
const removeLine = (list, width) => {
    const lists = splitList(width, list) || [];
    lists.shift();
    lists.pop();
    return lists.join("");
};
exports.removeLine = removeLine;
function splitList(w, s) {
    return s.match(new RegExp(".{1," + w + "}", "g"));
}
